import { useDebugValue } from 'react';
/**
 * Debugs the return value of a custom hook so that it can be easily viewed in react devtools
 *
 * @param {Function} hookFunction - A custom react hook
 */

export function debugHook(hookFunction) {
  const wrapped = (...args) => {
    const hookReturnValue = hookFunction(...args); // eslint-disable-next-line react-hooks/rules-of-hooks

    useDebugValue(hookReturnValue);
    return hookReturnValue;
  };

  return wrapped;
}
/**
 * Set the hook name, so that it can be identified in devtools even after the code has been minified
 *
 * @param {Function} hookFunction - A custom react hook function
 * @param {String} name - The name of the hook
 */

export function setHookName(hookFunction, name) {
  Object.defineProperty(hookFunction, "name", {
    value: name
  });
  return hookFunction;
}
/**
 * Wrap a custom hook with some devtools tweaks
 *
 * @param {Function} hookFunction - A custom react hook function
 * @param {String} name - The name of the hook
 */

export default function (hookFunction, name) {
  return setHookName(debugHook(hookFunction), name);
}